module.exports = __webpack_public_path__ + "media/images/hh-icon-2486c9d5754d29b4e61671589b740520.svg";